export const star = [{
  text: '非常不满意，生气',
  value: 1
}, {
  text: '不满意，有点失望',
  value: 2
}, {
  text: '一般，还需改进',
  value: 3
}, {
  text: '满意，很喜欢',
  value: 4
}, {
  text: '非常满意，特别喜欢',
  value: 5
}]



// WEBPACK FOOTER //
// ./src/pages/webot/evaluate/star.js